import PropTypes from 'prop-types';

/**
 * A reusable component for displaying status and ETA information
 * @param {Object} props
 * @param {Object} props.latestStatus - The latest status object
 * @param {Object} props.latestEta - The latest ETA object
 * @returns {string} The formatted status display string
 */
const StatusDisplay = ({ latestStatus, latestEta, isTimeout }) => {
  if (isTimeout) {
    return 'Request Failed – Please Contact Air Service via Telephone.';
  }

  return `${latestStatus?.status?.display || ''}${
    latestEta ? ` - ${latestEta}` : ''
  }`;
};

StatusDisplay.propTypes = {
  latestStatus: PropTypes.shape({
    status: PropTypes.shape({
      display: PropTypes.string,
    }),
  }),
  latestEta: PropTypes.shape({
    display: PropTypes.string,
  }),
};

export default StatusDisplay;
